import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveEntry24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMoveEntry24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M9.047 10.19a.9.9 0 0 1-.9.901H2.33a.9.9 0 0 1 0-1.8h5.817a.9.9 0 0 1 .9.9m-.16 3.61a.9.9 0 0 1-.9.9H4.031a.9.9 0 0 1 0-1.8h3.956a.9.9 0 0 1 .9.9m12.776-1.41a5.55 5.55 0 0 1-5.544 5.266l-.285-.008a5.551 5.551 0 1 1 5.837-5.544zm-1.792-.286a3.752 3.752 0 1 0-7.505.003 3.752 3.752 0 0 0 7.505-.003"
            />
        </svg>
    );
}
export default memo(IconMoveEntry24);
